export const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max);

export const getWidthPercent = (progress: number): number =>
  clamp(Math.round(progress), 0, 100);
